import type { ProgramRow as YoursRow } from "../types";
import { ProgramRow, type ProgramViewer } from "./program-row";
import s from "../onepager.module.css";

export function Yours({
  yours,
  viewer,
}: {
  readonly yours: readonly YoursRow[];
  readonly viewer: ProgramViewer;
}) {
  const first = yours[0];

  if (!first)
    return (
      <p className={s.empty}>
        You haven&apos;t submitted a program yet. Tell your coding agent to
        submit one: it follows <a href={`${viewer.playPath}.md`}>play.md</a>.
      </p>
    );

  const champion = yours.find((p) => p.champion) ?? first;
  const earlier = yours.length - 1;
  const meta = programSummary(champion);
  return (
    <ul className={s.programs}>
      <ProgramRow
        key={champion.label}
        label={champion.label}
        meta={meta}
        id={champion.id}
        viewer={viewer}
      />
      {earlier > 0 ? (
        <li className={s.more}>
          and {earlier} earlier version{earlier === 1 ? "" : "s"}
        </li>
      ) : null}
    </ul>
  );
}

function programSummary(program: YoursRow): string {
  const submitted = program.submittedAt
    ? new Date(program.submittedAt).toLocaleDateString("en", {
        month: "short",
        day: "numeric",
        timeZone: "UTC",
      })
    : null;
  return [
    program.champion ? "champion" : program.status,
    program.rank
      ? `rank ${program.rank}${program.of ? ` of ${program.of}` : ""}`
      : program.champion
        ? "unranked"
        : null,
    program.score !== null ? `score ${program.score}` : null,
    submitted ? `submitted ${submitted}` : null,
  ]
    .filter(Boolean)
    .join(" · ");
}
